import { graphql, DataValue } from '@apollo/client/react/hoc';
import React from 'react';

import Text from 'components/Text';
import Heading from 'components/Heading';
import LoadingIndicator from 'components/LoadingIndicator';
import contentSourcesContentQuery from 'user/queries/contentSourcesContent.gql';
import type {
  ContentSourcesContent,
  ContentSourcesContentVariables,
} from 'user/queries/__generated__/ContentSourcesContent';
import EventTracking from 'lib/EventTracking';
import { mountModal } from 'lib/modal';
import LinkedContentPreviewModal from 'components/LinkedContentPreviewModal';
import AccountLinkingComposerSidebarContentItem from './AccountLinkingComposerSidebarContentItem';

type Props = {
  contentSource: any;
  query: string;
  addLinkedContent: (a: any) => void;
  onQueryFailed: () => void;
};

type InnerProps = {
  data?: DataValue<ContentSourcesContent>;
};

export class AccountLinkingComposerSidebarContentList extends React.Component<Props & InnerProps> {
  hovercardTriggers = [];

  renderItem = (item: any, index: number) => {
    const handleItemClicked = () => {
      if (index in this.hovercardTriggers) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'hideLayer' does not exist on type 'never... Remove this comment to see the full error message
        this.hovercardTriggers[index].hideLayer();
      }
      const { contentSource, addLinkedContent } = this.props;
      EventTracking.trackKey('account_linking.browse_content.item.click', {
        provider: contentSource.providerKey,
        composer_version: 'web_modal',
      });

      if (item.contentUrl) {
        addLinkedContent(item);
      }
    };

    const handleThumbnailClicked = () => {
      if (index in this.hovercardTriggers) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'hideLayer' does not exist on type 'never... Remove this comment to see the full error message
        this.hovercardTriggers[index].hideLayer();
      }
      mountModal(<LinkedContentPreviewModal linkedContent={item} />, this);
    };

    const registerHovercardTrigger = (trigger: any) => {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'any' is not assignable to type 'never'.
      this.hovercardTriggers[index] = trigger;
    };

    return (
      <AccountLinkingComposerSidebarContentItem
        key={index}
        item={item}
        handleItemClicked={handleItemClicked}
        handleThumbnailClicked={handleThumbnailClicked}
        registerHovercardTrigger={registerHovercardTrigger}
      />
    );
  };

  renderSection = (section: any, index: number) => {
    if (section.items.length === 0) {
      return null;
    }

    return (
      <div className="AccountLinkingComposerSidebarContent-section" key={index}>
        <Heading
          className="AccountLinkingComposerSidebarContent-section-title"
          level="2"
          levelStyle="3"
        >
          <Text color="chalkboard">{section.sectionTitle}</Text>
        </Heading>
        {section.items.map(this.renderItem)}
      </div>
    );
  };

  render() {
    const { data, contentSource, query, onQueryFailed } = this.props;

    if (data?.loading) {
      return (
        <LoadingIndicator
          className="AccountLinkingComposerSidebarServices-loading"
          align="center"
        />
      );
    }

    if (
      data?.error ||
      !data?.me ||
      !data?.me?.composer ||
      !data?.me?.composer.contentSourcesContent
    ) {
      onQueryFailed();

      return (
        <Text color="graphite" align="center">
          {`Failed to fetch ${contentSource.title} content. Please try again.`}
        </Text>
      );
    }
    if (data?.me.composer.contentSourcesContent.length === 0) {
      if (query.length > 0) {
        return (
          <Text color="graphite" align="center">
            No results found
          </Text>
        );
      } else {
        return (
          <Text color="graphite" align="center">
            {`No content found on ${contentSource.title}`}
          </Text>
        );
      }
    }
    return <div>{data?.me.composer.contentSourcesContent.map(this.renderSection)}</div>;
  }
}

const withContent = graphql<
  Props,
  ContentSourcesContent,
  ContentSourcesContentVariables,
  InnerProps
>(contentSourcesContentQuery, {
  options: ({ contentSource, query }) => ({
    fetchPolicy: 'network-only',
    variables: {
      source: contentSource.providerKey,
      query,
    },
  }),
});

export default withContent(AccountLinkingComposerSidebarContentList) as React.ComponentType<Props>;
